import authReducer from './auth.slice'
import diagnosticReducer from './diagnostic.slice'

const rootReducer = {
  auth: authReducer,
  diagnostic: diagnosticReducer,
}

export default rootReducer
